import { Component, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { IFormFields } from 'app/shared/Domains/IFormFields';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-form-fields',
  templateUrl: './app-form-fields.component.html',
  providers: [MessageService],
  styles: [`
      :host ::ng-deep .p-cell-editing {
          padding-top: 0 !important;
          padding-bottom: 0 !important;
      }
  `]
})
export class AppFormFieldsComponent implements OnInit {
  products1: IFormFields[];

  products2: IFormFields[];

  statuses: SelectItem[];

  clonedProducts: { [s: string]: IFormFields; } = {};
  memberFormField:IFormFields;
  memberFieldDialogVisibility: boolean = false;
  user: IUser;
  constructor(
    private LanguageService: LanguageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private appServiceManager: AppServiceManager) {
  }

	setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AppFormFieldsComponent", label);
  }
  ngOnInit() {
    // this.productService.getProductsSmall().then(data => this.products1 = data);
    // this.productService.getProductsSmall().then(data => this.products2 = data);
    this.user = AuthService.getLoggedInUser();
    this.statuses = [{ label: 'In Stock', value: 'INSTOCK' }, { label: 'Low Stock', value: 'LOWSTOCK' }, { label: 'Out of Stock', value: 'OUTOFSTOCK' }]
    this.memberFormField = new IFormFields();
  }

  onRowEditInit(product: IFormFields) {
    // this.clonedProducts[product.id] = { ...product };
  }

  onRowEditSave(product: IFormFields) {
    // if (product.price > 0) {
      // delete this.clonedProducts[product.id];
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Product is updated' });
    // }
    // else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid Price' });
    // }
  }

  onRowEditCancel(product: IFormFields, index: number) {
    // this.products2[index] = this.clonedProducts[product.id];
    // delete this.products2[product.id];
  }

  createFormField(){
    this.confirmationService.confirm({
      message: "Are you sure you want to create form field?",
      accept: () => {
        this.memberFormField.branch = this.user.branch;
        this.memberFormField.company = this.user.company;
        this.memberFormField.mandatory = false;
        this.memberFormField.createdBy = this.user._id;
        this.memberFormField.form = "MemberForm";
        this.appServiceManager.post("companies/formField", this.memberFormField).subscribe((res: any) => {
          if (res) {
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Form Field Create Successfully' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.memberFieldDialogVisibility = !this.memberFieldDialogVisibility;
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }

  updateFormField(){
    this.confirmationService.confirm({
      message: "Are you sure you want to update form field?",
      accept: () => {
        this.memberFormField.branch = this.user.branch;
        this.memberFormField.company = this.user.company;
        this.memberFormField.mandatory = false;
        this.memberFormField.modifiedBy = this.user._id;
        this.memberFormField.form = "MemberForm";
        this.appServiceManager.put("companies/formField", this.memberFormField).subscribe((res: any) => {
          if (res) {
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Form Field Create Successfully' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.memberFieldDialogVisibility = !this.memberFieldDialogVisibility;
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }

}
